module.exports = __webpack_public_path__ + "img/sand-dune-decal-27.2a59b282.png";